import { twMerge } from 'tailwind-merge';
import { Platforms } from '@/common/constants';
import type { HorizontalScrollViewProps } from './HorizontalScrollView.types';
import DesktopHorizontalScrollView from './DesktopHorizontalScrollView';

export default function HorizontalScrollView(props: HorizontalScrollViewProps) {
  const { className, platform = Platforms.DESKTOP, ...rest } = props;

  if (platform === Platforms.MOBILE) {
    return (
      <div
        className={twMerge(
          'overflow-y-hidden overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]',
          className,
        )}
        {...rest}
      />
    );
  }

  return <DesktopHorizontalScrollView {...props} />;
}
